export default "__VITE_ASSET__DiYpN0tS__"